import axiosInstance from '@api/axios-instance.ts';
import {
  CurrenciesModel,
  Organization,
  OrganizationInfoReqBodyModel,
  ProfileModel
} from '@models/profile.model.ts';

export const getProfile = async (): Promise<ProfileModel> => {
  const response = await axiosInstance.get('/pms/users/profile');
  return response.data;
};

export const getCurrencies = async (): Promise<CurrenciesModel[]> => {
  const response = await axiosInstance.get('/pms/currencies');
  return response.data;
};

export const uploadFile = async (body: {
  avatar: string;
}): Promise<ProfileModel | undefined> => {
  try {
    const response = await axiosInstance.put(`/pms/users/avatar`, body);

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const editOrganization = async (
  body: OrganizationInfoReqBodyModel,
  id: number
): Promise<Organization> => {
  return await axiosInstance.put(`/pms/organizations/${id}`, body);
};

export const organizationBranding = async (
  body: any,
  id: number
): Promise<Organization> => {
  return await axiosInstance.put(`/pms/organizations/${id}/branding`, body);
};

export const getPmsConfig = async (propertyId: number): Promise<any> => {
  const response = await axiosInstance.get(
    `/integrations-platform/pms-configs/property/${propertyId}`
  );
  return response.data;
};
